import { Component, Input } from '@angular/core';
import { ControlTemplate } from 'src/app/rent-module/components/form/entities/controlTemplate';


@Component({
  selector: 'app-numberInput-control-value-view, [app-numberInput-control-value-view]',
  templateUrl: './numberInput-control-value-view.component.html',
  styleUrls: ['./numberInput-control-value-view.component.scss']
})
export class NumberInputControlValueViewComponent {

  @Input() controlTemplate: ControlTemplate;

  constructor(
  ) {
  }

  public showSuffix(): boolean {
    return this.controlTemplate?.settings?.suffix;
  }

}
